<template>
  <!-- 司机招募配置统计页面 -->
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    append-to-body
    width="85%"
  >
    <div class="handle-box-search">
      <div class="handle-box" style="display: flex">
        <div style="width: 70%">
          <el-row class="head-search">
          
            <el-col :span="12">
              <span class="title">日期:</span>
              <el-date-picker
                v-model="search_data.insert_month"
                type="month"
                placeholder="选择日期"
                format="yyyy-MM"
                value-format="yyyy-MM"
                style="width: 200px"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="12">
              <span class="title">司机手机号:</span>
              <!-- 搜索司机手机号 -->
              <el-input
                v-model="search_data.phone"
                placeholder="请输入司机手机号"
                class="handle-input mr10"
                @keyup.enter.native="searchDriverRecruitRewardList"
              ></el-input>
            </el-col>
          </el-row>
          <el-row class="head-search">
            
            <el-col :span="12">
              <span class="title">状态:</span>
              <!-- 搜索状态 -->
              <el-select
                clearable
                @change="statusChange"
                v-model="search_data.is_give"
                placeholder="请选择状态"
                style="width: 200px; margin-right: 20px"
              >
                <el-option label="待发放" value="0"> </el-option>
                <el-option label="已发放" value="1"> </el-option>
                <el-option label="回收" value="2"> </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <!-- 奖励发放审核次数等数据统计 -->

        <div class="amountNum">
          <dir class="line"></dir>
          <div class="left">
            <div class="up" style="margin-bottom: 30px">
              <div class="child">
                <div style="font-weight: 700; font-size: 16px">总览</div>
              </div>
              <div class="child">
                <div>奖励金</div>
                <div>{{ total.amount }}</div>
              </div>
              <div class="child">
                <div>优享券</div>
                <div>{{ total.priority_coupon }}</div>
              </div>
              <div class="child">
                <div>表现分</div>
                <div>{{ total.monitor_points }}</div>
              </div>
            </div>
            <div class="up" style="margin-top: -10px">
              <div class="child">
                <div style="font-weight: 700; font-size: 16px">已发</div>
              </div>
              <div class="child">
                <div>奖励金</div>
                <div>{{ sent_total.amount }}</div>
              </div>
              <div class="child">
                <div>优享券</div>
                <div>{{ sent_total.priority_coupon }}</div>
              </div>
              <div class="child">
                <div>表现分</div>
                <div>{{ sent_total.monitor_points }}</div>
              </div>
            </div>
            <div class="up" style="margin-top: 10px">
              <div class="child">
                <div style="font-weight: 700; font-size: 16px">待发</div>
              </div>
              <div class="child">
                <div>奖励金</div>
                <div>{{ unset_total.amount }}</div>
              </div>
              <div class="child">
                <div>优享券</div>
                <div>{{ unset_total.priority_coupon }}</div>
              </div>
              <div class="child">
                <div>表现分</div>
                <div>{{ unset_total.monitor_points }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-button
        type="primary"
        icon="el-icon-search"
        @click="searchDriverRecruitRewardList"
        >搜索</el-button
      >
      <el-button type="primary" icon="el-icon-search" @click="refresh"
        >重置</el-button
      >
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      header-cell-class-name="table-header"
    >
      <el-table-column prop="name" label="司机姓名" min-width="140">
      </el-table-column>

      <el-table-column prop="phone" label="司机手机号" min-width="100">
      </el-table-column>

      <el-table-column prop="person_num" label="累计招募人数" min-width="100">
      </el-table-column>
      <el-table-column prop="is_give" label="状态" min-width="100">
      </el-table-column>
      <el-table-column prop="content" label="奖励内容" min-width="100">
      </el-table-column>


      <el-table-column prop="send_stamp" label="发放日期" min-width="90">
      </el-table-column>

      <el-table-column label="操作" width="180" align="center">
        <template slot-scope="scope">
          <!-- 查看招募人员按钮 -->
          <el-button type="" size="mini" @click="detail(scope.row)"
            >查看招募人员
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 查看组件 -->
    <driverRecruitList
      :isShow="view_isShow"
      :data="recruitData"
    ></driverRecruitList>

    <!-- 分页组件 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="search_data.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="search_data.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="result_data.count"
      >
      </el-pagination>
    </div>
  </el-dialog>
</template>

<script>
let _this;
import driverRecruitList from "./driverRecruitList.vue";

export default {
  components: {
    driverRecruitList,
  },
  props: {
    isShow: Boolean,
    data: "",
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;

      console.log("司机招募配置统计页面");
      _this.searchDriverRecruitRewardList();
    },
  },
  created() {
    _this = this;
  },
  data() {
    return {
      recruitData: {},
      rewardType: "1", // 奖励对象 默认为1  1是司机，2是用户
      total: {}, //总览
      sent_total: {}, //已发
      unset_total: {}, //待发
      condition_order: "",
      condition_time: "",

      view_isShow: false,

      // 预约自定义时间
      order_time_array: [],
      show: false,

      search_data: {
        page: 1,
        limit: 10,
        is_give: "",
        insert_month: "",
        phone: "",
      },

      tableData: [],
      result_data: {},
    };
  },
  methods: {
    statusChange() {
      _this.searchDriverRecruitRewardList();


    },
    // 关闭方法
    closeDialog() {
      _this.show = false;
      _this.search_data = {
        page: 1,
        limit: 10,
        is_give: "",
        insert_month: "",
        phone: "",
      };
    },

    detail(val) {
      console.log(33333333);
      _this.view_isShow = !_this.view_isShow;
      _this.recruitData = val;
      console.log(_this.view_isShow, "_this.view_isShow");
    },

    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      _this.search_data.limit = val;

      //初始化列表
      _this.pages_function();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data.page = val;
      //初始化列表
      _this.pages_function();
    },
    //翻页组件的回调
    pages_function() {
      //初始化列表
      _this.driverRecruitRewardList();
    },

    // 搜索时间选择触发
    timeChange(parm, val) {
      if (_this.order_time_array == null) {
        _this.search_data.fixed_time = [];
      } else {
        _this.search_data.fixed_time = JSON.stringify(
          ["between"].concat(_this.order_time_array)
        );
      }
    },
    searchDriverRecruitRewardList() {
      console.log("3434");
      _this.search_data.page = 1;
      _this.driverRecruitRewardList();
    },
    driverRecruitRewardList() {
      let url = "/recruit/driverRecruitRewardList";
      _this.rewardType == "1"
        ? "/recruit/driverRecruitRewardList"
        : "/recruit/driverRecruitRewardList";

      _this.$post(url, _this.search_data).then((res) => {
        _this.result_data = res;
        _this.tableData = res.data.list;
        _this.total = res.data.total.total;
        _this.unset_total = res.data.total.unset_total;
        _this.sent_total = res.data.total.sent_total;
      });
    },
    refresh() {
      _this.search_data = {
        page: 1,
        limit: 10,
        is_give: "",
        insert_month: "",
        phone: "",
      };
    },
  },
};
</script>

<style scoped>
.child {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.up {
  display: flex;
}
.left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.amountNum {
  display: flex;
  justify-content: space-between;
  width: 30%;
  margin-bottom: 10px;
}
.line {
  background-color: #909399;
  width: 1px;
}
.child > div {
  margin-right: 20px;
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
}
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  max-width: 150px;
  display: inline-block;
}

.table {
  width: 100%;
  font-size: 14px;
}

.red {
  color: #ff0000;
}

.mr10 {
  margin-right: 10px;
}

.table-td-thumb {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.el-table__row {
  height: 100px;
}

.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
}
</style>
